<template>
<div class="error-component error-cant-reach-server card border-warning text-center">
  <div class="card-header bg-warning">
    มีข้อผิดพลาดเกิดขึ้น
  </div>
  <div class="card-body">   
    <template v-if="!isKnownError">
      <p class="card-text">{{text}} ({{errorData.code}})</p>
      <button v-if="!disableCTA" class="btn btn-primary" @click="invokeCTA()">{{ctaText}}</button>
      <span v-else>กรุณา{{ctaText}}</span>
    </template>
    <template v-else>
      <p class="card-text">{{knownErrorText}}<br><small style="opacity: 0.2;">({{errorData.code}})</small></p>
    </template>
  </div>
</div>
</template>

<script>
export default {
  data: () => ({
    isKnownError: false,
    knownErrorText: '',
  }),
  mounted () {
    this.handleKnownError()
  },
  methods: {
    handleKnownError () {
      const code = this.errorData.code
      if (code === 'E-CONTRACT_CREATE_DAY_LIMIT_REACHED') {
        this.isKnownError = true;
        this.knownErrorText = 'ถึงลิมิตการสร้างสัญญาต่อวัน กรุณาลองใหม่ในวันถัดไป'
      }
      if (code === 'E-LEND_AMOUNT_NOT_ALLOW') {
        this.isKnownError = true;
        this.knownErrorText = 'จำนวนเงินผิดพลาด เนื่องจากเงินดาวน์มากกว่าจำนวนเงินที่ทำสัญญาซื้อขาย หรือ ยอดเงินไม่อนุญาตให้กู้'
      }
    },
    invokeCTA () {
      this.$emit('clickCTA')
    },
  },
  props: {
    text: {
      type: String,
      default: 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้'
    },
    ctaText: {
      type: String,
      default: 'ลองอีกครั้ง'
    },
    disableCTA: {
      type: Boolean,
      default: false
    },
    errorData: {
      type: Object
    }
  }
}
</script>

<style lang="scss">
</style>
